import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {CardComponent} from "../../../libs/card/card.component";
import {CardHeaderComponent} from "../../../libs/card/card-header/card-header.component";
import {CardBodyComponent} from "../../../libs/card/card-body/card-body.component";
import {TranslatePipe} from "@ngx-translate/core";
import {BrowserCheckService} from "../../../services/browser-check.service";
import {ExternalLinkDirective} from "../../../libs/utils/external-link.directive";
import {ButtonComponent} from "../../../libs/button/button.component";
import {IconComponent} from "../../../libs/icon/icon.component";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'acc-browser-check',
  imports: [
    CardComponent,
    CardHeaderComponent,
    CardBodyComponent,
    TranslatePipe,
    ExternalLinkDirective,
    ButtonComponent,
    IconComponent,
    NgbTooltip
  ],
  templateUrl: './browser-check.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './browser-check.component.css'
})
export class BrowserCheckComponent {

  protected readonly chromeVersion = BrowserCheckService.CHROME_VERSION;
  protected readonly firefoxVersion = BrowserCheckService.FIREFOX_VERSION;
  protected readonly edgeVersion = BrowserCheckService.EDGE_VERSION;

  private readonly browserCheckService: BrowserCheckService = inject(BrowserCheckService);

  protected ignoreBrowserCheck(): void {
    this.browserCheckService.setSupportedForce(true);
  }
}
